import 'twin.macro';
import React, { useEffect, useState } from 'react';
import Dialog from '@teetsh/app/src/components/Dialog';
import {
  ClassroomsMapping,
  ClassroomMapping,
  NO_COPY,
} from '@teetsh/app/src/components/EntitiesSelectorModals/ClassroomsMappingModal/ClassroomsMapping';
import useClassrooms from '@teetsh/app/src/containers/App/context/ClassroomsContext/useClassrooms';
import { StrapiEDT } from '@teetsh/app/src/containers/EmploiDuTemps/New/types';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { useSchoolGoTo } from '@teetsh/app/src/containers/App/useSchoolGoTo';
import useCreateEDT from '@teetsh/app/src/queries/edt/useCreateEDT';
import { matchClassrooms } from '@teetsh/app/src/containers/Eleves/Import/File/Finalize/matchClassrooms';
import { useTranslation } from 'react-i18next';

interface Props {
  strapiEdt?: StrapiEDT;
  onClose: () => void;
}

export function ClassroomsMappingModal(props: Props) {
  const { onClose, strapiEdt } = props;
  const goTo = useSchoolGoTo();
  const destClassrooms = useClassrooms();
  const [classroomMapping, setClassroomMapping] = useState<ClassroomMapping[]>(
    (strapiEdt?.classrooms || []).map(c => ({ from: c })),
  );
  const { t } = useTranslation(['emploiDuTemps', 'common']);
  const createEDT = useCreateEDT();
  const onCreate = (id?: string) => {
    const clMap = classroomMapping.reduce<{
      [key: string]: string;
    }>(
      (acc, { from, to }) => {
        if (to) {
          return { ...acc, [from]: to };
        }
        return { ...acc, [from]: 'CREATE' };
      },
      {} as {
        [key: string]: string;
      },
    );
    return createEDT({ strapiTemplateId: id, classroomMapping: clMap }).then(
      edt => goTo(`emploi-du-temps/${edt.id}`),
    );
  };
  useEffect(() => {
    const res = matchClassrooms(
      (strapiEdt?.classrooms || []).map(cl => ({ name: cl })),
      destClassrooms,
    ).map(c => ({
      from: c.name as string,
      to: c.match?.id,
    }));
    setClassroomMapping(res);
  }, [(strapiEdt?.classrooms || []).join('')]);
  return (
    <div>
      <Dialog
        isOpen={!!props.strapiEdt}
        onClose={onClose}
        closeButton
        disabledClickOutside={false}
      >
        <Dialog.Header title={t('common:classroomMapping.title')} />
        <Dialog.Body>
          <div tw="py-2 px-4 flex justify-center">
            <div tw="w-full max-w-sm">
              {strapiEdt && (
                <ClassroomsMapping
                  srcClassrooms={strapiEdt.classrooms.map(cl => ({
                    id: cl,
                    name: cl,
                    cycle: [],
                    events: [],
                    workingDays: [],
                    tags: [],
                    order: 0,
                  }))}
                  destClassrooms={destClassrooms}
                  value={classroomMapping}
                  onChange={setClassroomMapping}
                  enableCreateClassroom
                />
              )}
            </div>
          </div>
        </Dialog.Body>
        <Dialog.Footer>
          <Button minimal large type="button" onClick={onClose}>
            {t('common:buttons.cancel')}
          </Button>
          <Button
            large
            disabled={
              (classroomMapping || []).map(c => c.to).filter(c => c !== NO_COPY)
                .length === 0
            }
            intent="primary"
            onClick={() => onCreate(strapiEdt?.documentId)}
          >
            {t('common:buttons.validate')}
          </Button>
        </Dialog.Footer>
      </Dialog>
    </div>
  );
}
